export const COMPLEXITY = {
  EASY: 'Easy',
  MEDIUM: 'Medium',
  HARD: 'Hard',
};
